import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=7ed0d49b&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=7ed0d49b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed0d49b",
  null
  
)

export default component.exports